import appConfig from '@nerdwallet/app-config';
import { HOMEPAGE as analyticsBase } from '../analytics-constants';

export default {
  titleImage: `${appConfig.ASSETS_URL}/images/homepage/nw_advisors.png`,
  subtitle:
    'Need more guidance? Get unlimited 1:1 advice from a Certified Financial Planner™.',
  backgroundColor: '#EEF7FF',
  backgroundColorMobile: '#DEEFFF',
  ctaButtonText: 'join for $30/month',
  ctaLinkUrl: 'http://nerdwalletadvisors.com',
  visualBackgroundImageMobileUrl: `${appConfig.ASSETS_URL}/images/homepage/nw_advisors_mobile.png`,
  visualBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/homepage-nw-advisor-1280.jpg`,
  elementImpressionEntityName:
    analyticsBase.entity_names.secondary_campaign_module, // used for the Impression of the component
  elementImpressionSectionName: analyticsBase.section_name,
  trkQueryParam: analyticsBase.entity_names.secondary_campaign_module, // used to append to the URL when the button is clicked
};
